export default __webpack_public_path__ + "static/media/hero-banner.94ba93f1.png";